import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "integrations" };
const _hoisted_2 = { class: "main-header" };
const _hoisted_3 = { class: "section-title" };
const _hoisted_4 = { class: "integrations__content" };
import Icon from "@astina/paloma-common-ui/src/components/Icon.vue";
import Navigation from "@astina/paloma-common-ui/src/components/Navigation.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'IntegrationView',
    setup(__props) {
        const tabItems = [
            {
                name: 'integration_config',
                permission: 'PORTAL_INTEGRATIONS_SETTINGS'
            },
            {
                name: 'integration_export',
                permission: 'PORTAL_INTEGRATIONS_EXPORT'
            },
            {
                name: 'integration_import',
                permission: 'PORTAL_INTEGRATIONS_IMPORT'
            },
        ];
        return (_ctx, _cache) => {
            const _component_router_view = _resolveComponent("router-view");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("header", _hoisted_2, [
                    _createElementVNode("h1", _hoisted_3, [
                        _createVNode(Icon, { name: "exchange" }),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('nav.integration')), 1)
                    ]),
                    _cache[0] || (_cache[0] = _createTextVNode()),
                    _createVNode(Navigation, {
                        items: tabItems,
                        type: "content"
                    })
                ]),
                _cache[1] || (_cache[1] = _createTextVNode()),
                _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_router_view)
                ])
            ]));
        };
    }
});
